<ui-panel [panelTitle]="route().title" [noGrow]="true">
  <dl>
    <dt>From</dt>
    <dd>{{ route().sourceLabel }}</dd>
    <dt>Result</dt>
    <dd>{{ route().resultLabel }}</dd>
    <dt>Movement</dt>
    <dd>{{ route().movementLabel }}</dd>
    <dt>Destination</dt>
    <dd>{{ route().destinationLabel }}</dd>
  </dl>
  <p>{{ route().description }}</p>
  <p class="inspection-note">{{ route().completionNote }}</p>
  @if (route().disabledReason; as reason) {
    <p id="workflow-route-inspection-reason" role="note">{{ reason }}</p>
  }
  <button
    uiButton
    type="button"
    severity="primary"
    [outlined]="false"
    [disabled]="blocked() || !route().canOpenEditor"
    [attr.aria-describedby]="
      route().disabledReason ? 'workflow-route-inspection-reason' : null
    "
    (click)="requestEditor()"
  >
    Open routing editor
  </button>
  <details>
    <summary>Exact route details</summary>
    <dl>
      @for (fact of route().facts; track $index) {
        <dt>{{ fact.label }}</dt>
        <dd>{{ fact.value }}</dd>
      }
    </dl>
    @if (route().declaration; as declaration) {
      <pre>{{ declaration }}</pre>
    }
  </details>
</ui-panel>
